import React, {useContext, useMemo} from 'react';
import {Col, Form, FormItemProps} from 'antd';
import {ProFormContext} from '../../context';

export interface FormFieldProps<Values = any> extends FormItemProps<Values> {
    colSize?: number;
    disabled?: boolean; // 字段是否禁用, 注意, 当Field和ProForm值冲突时优先使用Field的值
    children: React.ReactElement;
}

export function FormField<T>({
    children,
    colSize = 1,
    disabled,
    style,
    className,
    ...props
}: FormFieldProps<T>) {
    const {
        columns,
        noStyle,
        disabled: ctxDisabled,
    } = useContext(ProFormContext);
    const mergedSpan = Math.ceil(24 / columns) * colSize;

    // 字段是否禁用
    const fieldDisabled = useMemo(
        () => (disabled === undefined ? ctxDisabled : disabled),
        [disabled, ctxDisabled],
    );

    if (props.noStyle || (noStyle && !props.noStyle))
        return <Form.Item {...props}>{children}</Form.Item>;

    return (
        <Col span={mergedSpan} style={style} className={className}>
            <Form.Item style={{width: '100%'}} {...props}>
                {React.cloneElement(children, {
                    disabled: fieldDisabled,
                    ...children.props,
                })}
            </Form.Item>
        </Col>
    );
}
